export default __webpack_public_path__ + "static/android-ba976a485793bed397c7deef06fb6eb3.svg";